import React from 'react';
import Button from '../../Button';
import { CancelIcon as ClearIcon } from '../../icons';

export type SearchClearButtonProps = {
  value?: string | number;
  onClear?: () => void;
};

function SearchClearButton({ value, onClear }: SearchClearButtonProps) {
  if (value) {
    return (
      <Button
        className="elmo-search__btn-clear"
        isText={true}
        icon={<ClearIcon />}
        onClick={onClear}
      />
    );
  }

  return null;
}

export default SearchClearButton;
